module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer"
  }, [(_vm.item.attr === 'templateId') ? [_c('el-select', {
    attrs: {
      "disabled": _vm.item.nonEditable === 1,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleTemp
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  }, _vm._l((_vm.item.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  }))] : (_vm.item.attr === 'phone') ? _c('v-phone', {
    attrs: {
      "attrValue": _vm.form.phone
    },
    on: {
      "numChange": _vm.phoneSave,
      "update:attrValue": function($event) {
        _vm.$set(_vm.form, "phone", $event)
      }
    }
  }) : (_vm.item.attr === 'address') ? _c('v-address', {
    attrs: {
      "attrValue": _vm.form.address
    },
    on: {
      "change": _vm.addressSave
    }
  }) : (_vm.item.attr === 'userId') ? _c('v-manager', {
    attrs: {
      "item": _vm.item,
      "form": _vm.form
    }
  }) : (_vm.item.attr === 'name') ? _c('div', {
    staticClass: "customerName"
  }, [_c('el-input', {
    on: {
      "focus": function($event) {
        _vm.repeatListShow = true
      },
      "blur": function($event) {
        _vm.repeatListShow = false
      }
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNameCheck && _vm.repeatListShow && _vm.isCheckRepeat),
      expression: "isNameCheck && repeatListShow && isCheckRepeat"
    }],
    staticClass: "repeat-list"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listData.length),
      expression: "listData.length"
    }],
    staticClass: "title"
  }, [_vm._v("已存在以下客户，请勿重复添加")]), _vm._v(" "), _c('ul', _vm._l((_vm.listData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_vm._v(_vm._s(item.name))])
  }))])], 1) : (_vm.item.attr === 'addContact') ? _c('add-contact', {
    attrs: {
      "item": _vm.item,
      "child": _vm.child
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b5b015","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/customer/index.vue
// module id = 1307
// module chunks = 82